/* eslint-disable jsx-a11y/anchor-is-valid */
import {useEffect, useState} from 'react'
import {Modal} from 'react-bootstrap'
import axios from 'axios'
import Swal from 'sweetalert2'
import firebase from '../../../firebase/FirebaseConfig'
import apiConnect from '../../../api/apiConnect'

const AddUserModal = ({showMadalAddUser, setShowMadalAddUser, trigger, setTrigger}) => {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [repassword, setRepassword] = useState('')
  const [firstName, setFirstName] = useState('')
  const [lastName, setLastName] = useState('')
  const [userIdMalinOne, setUserIdMalinOne] = useState('')
  const [role, setRole] = useState('user')

  const [havedData, setHavedData] = useState(false)

  const handleCheckEmail = async () => {
    try {
      const response = await apiConnect.get(`/v1/users/get-user-by-email/${email}`)
      if (response.data.status == 'not-found') {
        setHavedData(false)
        Swal.fire({
          title: 'ไม่พบข้อมูลผู้ใช้ในระบบ',
          text: 'กรุณากรอกข้อมูลใหม่',
          icon: 'warning',
          confirmButtonText: 'OK',
        })
      } else {
        setHavedData(true)
        setFirstName(response.data.firstname)
        setLastName(response.data.lastname)
        setUserIdMalinOne(response.data.user_id)
      }
    } catch (error) {
      console.error('Error fetching data:', error)
    }
  }

  const closeModal = () => {
    setShowMadalAddUser(false)
    setHavedData(false)
    setFirstName('')
    setLastName('')
    setUserIdMalinOne('')
  }

  // const handleSubmit = async () => {
  //   if (password !== repassword) {
  //     Swal.fire({
  //       title: 'Error',
  //       text: 'Password and Re-Password do not match',
  //       icon: 'error',
  //       confirmButtonText: 'OK',
  //     })
  //     return
  //   }

  //   //Swal Loading
  //   Swal.fire({
  //     title: 'Loading...',
  //     text: 'Please wait',
  //     allowOutsideClick: false,
  //     didOpen: () => {
  //       Swal.showLoading()
  //     },
  //   })

  //   try {
  //     const userCredential = await firebase.auth().createUserWithEmailAndPassword(email, password)

  //     const firestore = firebase.firestore()
  //     await firestore
  //       .collection('users')
  //       .add({
  //         email: email,
  //         firstName: firstName,
  //         lastName: lastName,
  //         role: role,
  //         userId: userCredential.user.uid,
  //         userIdMalin1: userIdMalinOne,
  //         imageProfile:
  //           'https://images.unsplash.com/photo-1734792314923-83195abb4911?q=80&w=1974&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
  //       })
  //       .then((docRef) => {
  //         Swal.fire({
  //           title: 'Success',
  //           text: 'User created successfully',
  //           icon: 'success',
  //           confirmButtonText: 'OK',
  //         }).then(() => {
  //           closeModal()
  //         })
  //       })
  //       .catch((error) => {
  //         Swal.fire({
  //           title: 'Error',
  //           text: error.message,
  //           icon: 'error',
  //           confirmButtonText: 'OK',
  //         })
  //       })
  //   } catch (error) {
  //     Swal.fire({
  //       title: 'Error',
  //       text: error.message,
  //       icon: 'error',
  //       confirmButtonText: 'OK',
  //     })
  //   }
  // }

  const handleSubmit = async () => {
    if (password !== repassword) {
      Swal.fire({
        title: 'Error',
        text: 'Password and Re-Password do not match',
        icon: 'error',
        confirmButtonText: 'OK',
      })
      return
    }

    Swal.fire({
      title: 'Loading...',
      text: 'Please wait',
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading()
      },
    })

    try {
      const apiUrl = `https://apiadmin-qsac5kr5gq-as.a.run.app/v1/users/register`
      const response = await axios.post(
        apiUrl,
        {
          email: email,
          password: password,
          firstName: firstName,
          lastName: lastName,
          role: role,
          userIdMalinOne: userIdMalinOne,
        },
        {
          headers: {
            Authorization: `Bearer 4e98soIcO3oSAXmRch1S6dpEbSe6AoN6LmDZ4JhDlmzLfLp6N5`,
          },
        }
      )

      if (response.data.status == 'success') {
        Swal.fire({
          title: 'Success',
          text: 'User created successfully',
          icon: 'success',
          confirmButtonText: 'OK',
        }).then(() => {
          setTrigger(!trigger)
          closeModal()
        })
      } else {
        Swal.fire({
          title: 'Error',
          text: response.data.message,
          icon: 'error',
          confirmButtonText: 'OK',
        })
      }
    } catch (error) {
      Swal.fire({
        title: 'Error',
        text: error.response?.data?.message || error.message,
        icon: 'error',
        confirmButtonText: 'OK',
      })
    }
  }

  return (
    <>
      <Modal show={showMadalAddUser} onHide={() => closeModal()} size='lg'>
        <Modal.Header>
          <Modal.Title>
            <h3 className='fw-600'>Add new user (อยู่ในช่วงทดสอบระบบ)</h3>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className='p-2'>
            <div className='row'>
              <div className='col-9 col-sm-6 mb-5'>
                <label className='form-label'>Email</label>
                <input
                  type='text'
                  className='form-control'
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  disabled={havedData ? true : false}
                />
              </div>

              <div className='col-3 col-sm-6 mt-8'>
                <button className='btn btn-primary' onClick={() => handleCheckEmail()}>
                  Check
                </button>
              </div>

              {havedData && (
                <>
                  <div className='col-6 mb-5'>
                    <label className='form-label'>Password</label>
                    <input
                      type='text'
                      className='form-control'
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                    />
                  </div>
                  <div className='col-6 mb-5'>
                    <label className='form-label'>Re-Password</label>
                    <input
                      type='text'
                      className='form-control'
                      value={repassword}
                      onChange={(e) => setRepassword(e.target.value)}
                    />
                  </div>

                  <div className='col-6 mb-5'>
                    <label className='form-label'>First Name</label>
                    <input
                      type='text'
                      className='form-control'
                      value={firstName}
                      onChange={(e) => setFirstName(e.target.value)}
                    />
                  </div>
                  <div className='col-6 mb-5'>
                    <label className='form-label'>Last Name</label>
                    <input
                      type='text'
                      className='form-control'
                      value={lastName}
                      onChange={(e) => setLastName(e.target.value)}
                    />
                  </div>

                  <div className='col-12 mb-5'>
                    <label className='form-label'>Role</label>
                    <select
                      className='form-select'
                      aria-label='Select example'
                      value={role}
                      onChange={(e) => setRole(e.target.value)}
                    >
                      <option value='user'>User</option>
                      <option value='admin'>Admin</option>
                    </select>
                  </div>

                  <div className='col-12 mb-5'>
                    <label className='form-label'>User Id Malin1</label>
                    <input
                      type='text'
                      className='form-control'
                      value={userIdMalinOne}
                      onChange={(e) => setUserIdMalinOne(e.target.value)}
                      disabled={havedData ? true : false}
                    />
                  </div>
                </>
              )}
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          {havedData && (
            <button className='btn btn-primary' onClick={() => handleSubmit()}>
              Submit
            </button>
          )}
          <button className='btn btn-secondary' onClick={() => closeModal()}>
            ปิด
          </button>
        </Modal.Footer>
      </Modal>
    </>
  )
}

export {AddUserModal}
